/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';

interface IPopContentProps {
  justify?: string;
}

interface IPopItemProps {
  disabled?: boolean;
}

export const SearchHeaderBar = styled.div`
  min-height: 70px;
  background: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #b0b0b0;
  padding: 0.15rem 1rem;
`;

export const HelpIcon = styled(NeuIcon)`
  padding-bottom: 2px;
`;

export const HintSection = styled.div<{ offset?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  margin-left: 5px;
  margin-top: ${({ offset = 0 }) => offset};
  width: 100%;
`;

export const PopContent = styled.div<IPopContentProps>`
  display: flex;
  align-items: center;
  justify-content: ${props =>
    props.justify ? props.justify : 'space-between'};
  color: var(--primary-60);
`;

export const PopItem = styled.div<IPopItemProps>`
  color: var(--primary-60);
`;
